import { createContext } from 'react';
import type { AuthContextType } from '../types';

// Initial session state
export const AuthContext = createContext<AuthContextType | null>(null); 